var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-admin',[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.resp)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }